interface EmptyStateProps {
  title: string;
  body?: string;
}

/** Full-area empty state — dumb, prop-driven, mirrors LoadingState/ErrorState. */
export function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      <p className="text-[15px] font-medium text-ink">{title}</p>
      {body && <p className="text-sm text-mute">{body}</p>}
    </div>
  );
}
